import React from 'react';
import { useLocation } from 'react-router';

import * as convert from '_core/utils/convert';
import * as http from '_core/utils/http';
import { loadScript } from '_core/utils/async';


/*
  Отправить событие, если человек задержался на страничке 4 минуты:
    При показе:
      this.bookmarksTimeout = setTimeout(() => analytics.event({ action: 'bookmarks' }), 240000);
    При скрытии:
      clearTimeout(this.bookmarksTimeout);
*/


const globalThis = window;

const ANALYTIC_SERVICES = {
  // facebook
  
  /*facebook: {
    init: (service, state, setState) => {
      import('react-facebook-pixel').then((module) => {
        setState((state) => ({ ...state, [service.name]: module }));
        
        const advancedMatching = {};
        const options = { autoConfig: true };
        
        module.default.init('yourPixelIdGoesHere', advancedMatching, options);
      });
    },
    render: (service, state, setState, path) => {
      const module = state?.[service.name];
      
      if (!module || service.lastPath === path)
        return null;
      
      service.lastPath = path;
      
      module.default.pageView();
      
      return null;
    },
    
    pageview: (service, state, setState, path, param) => state?.[service.name]?.default.pageView(),
    event: (service, state, setState, path, { category, action, ...param }) => state?.[service.name]?.default.trackCustom(buildEventName(category, action), param),
    form: (service, state, setState, path, param) => null
  },*/
  
  // google
  
  /*google: {
    init: (service, state, setState) => {
      import('react-ga').then((module) => {
        setState((state) => ({ ...state, [service.name]: module }));
        
        module.default.initialize(service.id);
      });
    },
    render: (service, state, setState, path) => {
      const module = state?.[service.name];
      
      if (!module || service.lastPath === path)
        return null;
      
      service.lastPath = path;
      
      module.default.pageview(path);
      
      return null;
    },
    
    pageview: (service, state, setState, path, param) => state?.[service.name]?.default.pageview(param.path || path),
    event: (service, state, setState, path, { category, action, ...param }) => state?.[service.name]?.default.event({ category, action, ...param }),
    form: (service, state, setState, path, param) => null
  },*/
  
  // vkontakte
  
  vkontakte: {
    init: (service, state, setState) => {
      loadScript('https://vk.com/js/api/openapi.js?172').then(() => {
        const module = globalThis.VK;
        
        setState((state) => ({ ...state, [service.name]: module }));
        
        module.Retargeting.Init(service.id);
      });
    },
    render: (service, state, setState, path) => {
      const module = state?.[service.name];
      
      if (!module || service.lastPath === path)
        return null;
      
      service.lastPath = path;
      
      module.default.pageview(path);
      
      return null;
    },
    
    pageview: (service, state, setState, path, param) => state?.[service.name]?.Retargeting.Hit(),
    event: (service, state, setState, path, { category, action, ...param }) => state?.[service.name]?.Retargeting.Event(buildEventName(category, action)),
    form: (service, state, setState, path, param) => null
  },
  
  // yandex
  
  /*yandex: {
    init: (service, state, setState) => {
      import('react-yandex-metrika').then((module) => {
        setState((state) => ({ ...state, [service.name]: module }));
      });
    },
    render: (service, state, setState, path) => {
      const module = state?.[service.name];
      
      if (!module)
        return null;
      
      const YMInitializer = module.YMInitializer;
      
      return (
        <YMInitializer
          key={service.name}
          accounts={[Number(service.id)]}
          options={{
            accurateTrackBounce: true,
            clickmap: true,
            ecommerce: 'dataLayer',
            trackLinks: true,
            webvisor: true
          }}
        />
      );
    },
    
    pageview: (service, state, setState, path, param) => state?.[service.name]?.default('hit', param.path || path),
    event: (service, state, setState, path, { category, action, ...param }) => state?.[service.name]?.default('reachGoal', buildEventName(category, action), param),
    form: (service, state, setState, path, param) => null
  },*/
  
  // comagic
  
  comagic: {
    init: (service, state, setState) => {
      loadScript(http.param('https://app.comagic.ru/static/cs.min.js', { k: service.id })).then(() => {
        const module = globalThis.Comagic;
        
        setState((state) => ({ ...state, [service.name]: module }));
      });
    },
    render: (service, state, setState, path) => {
      
    },
    pageview: (service, state, setState, path, param) => null,
    event: (service, state, setState, path, { category, action, name, value }) => state?.[service.name]?.trackEvent(category, action, name, value),
    form: (service, state, setState, path, { callback, form, ...param }) => state?.[service.name]?.addOfflineRequest({ ...param, form_name: form }, callback)
  }
};


export const AnalyticsContext = React.createContext();

export const AnalyticsProvider = ({ config, children }) => {
  const location = useLocation();
  
  const [state, setState] = React.useState(null);
  
  React.useEffect(() => {
    getServices(config).forEach((item) => item.init(item, state, setState));
  }, [config]);
  
  const path = location.pathname;
  
  const analyticsControl = {
    pageview: ({ service, ...param }) => getServices(config, service).forEach((item) => item.pageview(item, state, setState, path, param)),
    event: ({ service, ...param }) => getServices(config, service).forEach((item) => item.event(item, state, setState, path, param)),
    form: ({ service, ...param }) => getServices(config, service).forEach((item) => item.form(item, state, setState, path, param))
  };
  
  return (
    <AnalyticsContext.Provider value={analyticsControl}>
      {children}
      
      {getServices().map((item) => item.render(item, state, setState, path))}
    </AnalyticsContext.Provider>
  );
};

export const useAnalyticsContext = () => React.useContext(AnalyticsContext);


const getServices = (config, service) => {
  service = Array.isArray(service) ? service
    : service ? convert.toString(service).trim().split('\s+')
    : Object.keys(ANALYTIC_SERVICES);
  
  return Object.entries(ANALYTIC_SERVICES)
    .map(([name, item]) => config?.[name] && { id: config?.[name], name, ...item })
    .filter((item) => item?.id && service.indexOf(item.name) >= 0);
};

const buildEventName = (category, action) => {
  category = convert.toString(category);
  action = convert.toString(action);
  
  return category && action ? category + '/' + action : category ? category : action;
};
